import { useEffect, useState } from 'react';

/** The stylesheet's phone breakpoint (KTD8). */
export const NARROW_QUERY = '(max-width: 700px)';

/** True below the 700px breakpoint, following resizes. False where `matchMedia` is missing. */
export function useNarrow(): boolean {
  const query = () => (typeof window.matchMedia === 'function' ? window.matchMedia(NARROW_QUERY) : null);
  const [narrow, setNarrow] = useState(() => query()?.matches ?? false);
  useEffect(() => {
    const list = query();
    if (!list) return;
    const update = () => setNarrow(list.matches);
    update();
    list.addEventListener?.('change', update);
    return () => list.removeEventListener?.('change', update);
  }, []);
  return narrow;
}
